var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"color-cards"},[(_vm.brandId != -1)?_c('div',{staticClass:"books"},_vm._l((_vm.curColor.pages),function(item,index){return _c('img',{key:index,attrs:{"src":item,"alt":""}})}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }